import { all } from 'redux-saga/effects';
import getMe from './getMe';

export const userSagas = function* root() {
  yield all([getMe()]);
};
